<template>
  <b-row>
    <b-col :sm="12">
      <h3>{{ $t("ADDON") }}:</h3>
    </b-col>
    <b-col>
      <v-text-field
        :value="selectedAddonDocContractorName"
        :label="$t('CONTRACTOR')"
        outlined
        disabled
        readonly
      ></v-text-field>
    </b-col>
    <b-col>
      <v-text-field
        :value="globalAddonDoc.num"
        :label="$t('DOC_NUM')"
        outlined
        disabled
        readonly
      ></v-text-field>
    </b-col>
    <b-col>
      <v-text-field
        :value="globalAddonDoc.date"
        :label="$t('DOC_DATE')"
        outlined
        disabled
        readonly
      ></v-text-field>
    </b-col>
    <b-col>
      <v-text-field
        :value="globalAddonDoc.totalCurrency"
        :label="$t('TOTAL_PRICE')"
        outlined
        disabled
        readonly
      ></v-text-field>
    </b-col>
    <b-col>
      <v-text-field
        :value="selectedAddonDocCurrencyCode"
        :label="$t('CURRENCY')"
        outlined
        disabled
        readonly
      ></v-text-field>
    </b-col>
    <b-col>
      <v-text-field
        :value="selectedAddonDocVatRate"
        :label="$t('VAT_GROUPS')"
        outlined
        disabled
        readonly
      ></v-text-field>
    </b-col>
  </b-row>
</template>
<script>
import _ from "lodash";
export default {
  name: "PreviewAddonDocInfo",
  inheritAttrs: false,
  props: {
    firstLoader: {
      type: Boolean,
      default: true
    },
    selectedAddonDocContractorName: {
      type: String,
      default: ""
    },
    stockActionTypeId: {
      type: Number,
      default: 1
    },
    vatGroups: {
      type: Array,
      default: function() {
        return [];
      }
    },
    currencies: {
      type: Array,
      default: function() {
        return [];
      }
    },
    globalAddonDoc: {
      type: Object,
      default: function() {
        return {
          visible: false,
          num: "",
          date: "",
          vatGroupId: 3,
          currencyId: 1,
          totalCurrency: "0.00"
        };
      }
    }
  },
  data() {
    return {};
  },
  components: {},
  mounted() {},
  computed: {
    tempFirstLoader: {
      get: function() {
        return this.firstLoader;
      },
      set: function(newValue) {
        this.$emit("update:firstLoader", newValue);
      }
    },
    selectedAddonDocCurrencyCode() {
      return this.selectedCurrencyCode(this.globalAddonDoc.currencyId);
    },
    selectedAddonDocVatRate() {
      return this.selectedVatRate(this.globalAddonDoc.vatGroupId);
    }
  },
  watch: {},
  methods: {
    selectedCurrencyCode(currencyId) {
      const currencyConst = _.find(this.currencies, { id: currencyId });
      if (currencyConst) {
        return currencyConst.code;
      } else {
        return "";
      }
    },
    selectedVatRate(vatGroupId) {
      const vatGroupConst = _.find(this.vatGroups, { id: vatGroupId });
      if (vatGroupConst) {
        return vatGroupConst.name;
      } else {
        return "";
      }
    }
  }
};
</script>
